/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./addPackReceiverJoin.vue?vue&type=template&id=5f01eb4e&scoped=true&"
import script from "./addPackReceiverJoin.vue?vue&type=script&lang=js&"
export * from "./addPackReceiverJoin.vue?vue&type=script&lang=js&"
import style0 from "./addPackReceiverJoin.vue?vue&type=style&index=0&id=5f01eb4e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f01eb4e",
  null
  
)

export default component.exports